// TODO - good candidate for @host-entry-preset inclusion (along with stub
// versions for tests...)
import type { App } from 'vue';
import { LocaleManager, RawBundleSource } from '@dialpad/i18n';
// dialtone does not have this import anymore. This import does not increase the bundle size, while overall bundle size requires deep analysis
// eslint-disable-next-line no-restricted-imports
import { setDateLocale } from '@dialpad/dialtone/vue3';
import { enUS } from 'date-fns/locale';

export async function hostI18NManager({
  vueApp,
}: {
  vueApp: App;
}): Promise<void> {
  const bundleSource = new RawBundleSource({
    resources: await RawBundleSource.dynamicResources([
      ['en-US', 'app-core', import('./en-US.ftl?raw')],
    ]),
  });

  const manager = new LocaleManager({
    bundleSource,
    preferredLocale: 'en-US',
    fallbackLocale: 'en-US',
    namespaces: ['app-core'],
  });

  await manager.ready;

  // TODO: Replace this with lazy loaded correct locale
  setDateLocale(enUS);

  // might move initial setup earlier then break this into a later hook?
  vueApp.use(manager);
}
